import styled from 'styled-components'

export const MainContainer = styled.div`
  display: grid;
  gap: 42px;
  grid-template-columns: 400px 1fr;
  margin-top: ${props => props.theme.spacing.sp32};

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`

export const TotalsContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

export const ChartColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  height: 100%;
`

export const HalfPieColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`
